import { sessionStoreGet, STORE_KEY_AUTH } from 'mailup-react-helpers'
import { type TracePayload } from 'Types/feTracingApi'

export const feTracingApiTraceMessage = async (
  payload: TracePayload
): Promise<void> => {
  await fetch(`${process.env.FETRACING_URL as unknown as string}/api/trace`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStoreGet(STORE_KEY_AUTH) as string}`
    },
    body: JSON.stringify(payload)
  })
}
